import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "customer", "submit", "count"]

  connect() {
    this.refresh()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked

    this.customerTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })

    this.refresh()
  }

  refresh() {
    const selectedCount = this.customerTargets.filter((checkbox) => checkbox.checked).length
    const hasSelection = selectedCount > 0

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = hasSelection && selectedCount === this.customerTargets.length
      this.selectAllTarget.indeterminate = hasSelection && selectedCount < this.customerTargets.length
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !hasSelection
      this.submitTarget.classList.toggle("cursor-not-allowed", !hasSelection)
      this.submitTarget.classList.toggle("opacity-50", !hasSelection)
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = selectedCount.toString()
    }
  }
}
